import React, { memo, useState, useCallback } from 'react';
import {
  Button,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  LoadingButton,
  Typography
} from 'investira.react.components';
import { useSelector, useDispatch } from 'react-redux';
import withResponseHandling from '../../hoc/withResponseHandling';
import withMessage from '../../hoc/withMessage';
import { CalendarPosicoes } from '../../components/molecules';
import { useCarteirasContext } from '../../contexts/CarteirasContext';
import { acCarteiraSelected } from '../../store/actions';
import dayjs from 'dayjs';

const INITIAL_DATE = dayjs();

const CopiarDataButtonDialog = memo(props => {
  const storeCarteiraCurrent = useSelector(store => store.carteiras.current);
  const storeDispatch = useDispatch();

  const { state, actions } = useCarteirasContext();

  const [open, setOpen] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);

  const isSamePosicaoDate = pSelectData => {
    return dayjs(state.data_posicao).isSame(pSelectData, 'day');
  };

  const xInitialData = {
    origem_carteira_id: state.carteira_id,
    origem_data: dayjs(state.data_posicao).format(),
    destino_carteira_id: state.carteira_id,
    destino_data: INITIAL_DATE.toISOString(),
    sobrescrever: true
  };

  const [data, setData] = useState(xInitialData);

  const handleChange = ({ data }) => {
    const xDate = data.format();
    if (isSamePosicaoDate(xDate)) {
      props.onMessageError(
        'A data selecionada é a mesma data da posição atual. Selecione outra data.'
      );
    }
    setData(prevState => {
      return { ...prevState, destino_data: xDate };
    });
  };

  const handleSubmit = pData => {
    setSubmitting(true);
    actions.clonePosicao(
      pData,
      rRes => {
        const { destino_data } = pData;

        const xPayload = {
          ...storeCarteiraCurrent,
          data_posicao: destino_data
        };

        storeDispatch(acCarteiraSelected(xPayload));
        props.onMessageSuccess('Posição copiada com sucesso!');
        handleClose();
      },
      rErr => {
        props.responseErrorHandling(rErr);
      },
      () => {
        setSubmitting(false);
      }
    );
  };

  const handleClickOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <React.Fragment>
      <Button
        variant="contained"
        size="small"
        onClick={handleClickOpen}
        startIcon={<Icon iconName="calendar" color="secondary" size={14} />}>
        Copiar p/ Data
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Selecione a data</DialogTitle>

        <DialogContent>
          <Typography variant="caption" color="textSecondary">
            Selecione a data de destino para a cópia da posição atual.
          </Typography>
          <CalendarPosicoes
            key="calendar-copiar-posicoes"
            carteiraId={state.carteira_id}
            dataPosicao={INITIAL_DATE}
            datasPosicoes={state.datas_posicoes}
            onClose={handleClose}
            onChange={handleChange}
            open={open}
            initialValue={INITIAL_DATE}
            refreshHighlightedDays={true}
            //onlyHighlightAble={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <LoadingButton
            variant="contained"
            type="button"
            onClick={() => handleSubmit(data)}
            loading={isSubmitting}
            disabled={isSamePosicaoDate(data.destino_data)}>
            Copiar
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
});

CopiarDataButtonDialog.displayName = 'CopiarDataButtonDialog';

export default withResponseHandling(withMessage(CopiarDataButtonDialog));
